module.exports = __webpack_public_path__ + "img/max-file-add--csv.73bffcc2.svg";